module.exports = __webpack_public_path__ + "img/ziyaad_hoosen.24257cb6.png";